import { FormControl } from '@angular/forms';

import { TRole } from 'src/app/modules/admin/roles/roles.types';
import { TTest } from '../types';
import { TestStatus, TestThresholds } from '../types/enums';

const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const randomString = (length = 10) => {
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const toCamelCase = (value: string): string => {
  const result = value?.replace(/\s+(.)/g, (match, group) =>
    group.toUpperCase()
  );
  return result?.charAt(0).toLowerCase() + result?.slice(1);
};

export const getErrorMessage = (value: FormControl): string => {
  for (const key in value.errors) {
    const error = value.errors[key];
    switch (key) {
      case 'email':
        return 'Please enter a valid email address';
      case 'required':
        return 'This field is required';
      case 'minlength':
        return `Min length: ${error.requiredLength}`;
      case 'maxlength':
        return `Max length: ${error.requiredLength}`;
    }
  }
  return '';
};

export const StringifyAndParse = (
  data: object | string,
  finalResult: 'parsed' | 'stringified' = 'parsed'
) => {
  if ((finalResult = 'parsed')) {
    return JSON.parse(JSON.stringify(data));
  }

  return JSON.stringify(JSON.parse(data as string));
};

export const hasRole = (
  userAvailableRoles: TRole[],
  roleToCheck: string,
  keyCheck: string = 'alias'
): boolean => {
  return Boolean(
    userAvailableRoles.find((role) => role[keyCheck as 'alias'] === roleToCheck)
  );
};

export const hasRoles = (
  userAvailableRoles: TRole[] = [],
  rolesToCheck: string[] = [],
  keyCheck: string = 'alias'
): boolean => {
  return userAvailableRoles
    .map((role) => role[keyCheck as 'alias'])
    .some((userRole) => rolesToCheck.includes(userRole));
};

export const getPerfomanceCssClass = (category: string) => {
  switch (category) {
    case TestThresholds.VeryHigh:
      return 'tw-bg-[#b2de84]';
    case TestThresholds.High:
      return 'tw-bg-[#e2eeda]';
    case TestThresholds.Average:
      return 'tw-bg-[#b5c6e7]';
    case TestThresholds.Moderate:
      return 'tw-bg-[#dfc77f]';
    case TestThresholds.Low:
      return 'tw-bg-[#dd9e76]';
    default:
      return '';
  }
};

export const getTestStatus = (tests: TTest[]): string => {
  const completed = tests?.every(
    (test) => test.status === TestStatus.Completed
  );
  const notStarted = tests?.some(
    (test) => test.status === TestStatus.NotStarted
  );
  const notCompleted = tests?.some(
    (test) => test.status === TestStatus.NotCompleted
  );

  if (completed) {
    return 'Completed';
  } else if (notStarted) {
    return 'Not Started';
  } else if (notCompleted) {
    return 'Not Completed';
  }
  return '';
};

export const camelCaseToWord = (text: string) => {
  const result = text.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const generateUniqueId = () => {
  return 'id-' + Math.random().toString(36).slice(2, 11);
};
